import {
  Box,
  Typography,
  Divider,
  IconButton,
  Chip,
  CircularProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import useValidValues from "../hooks/use-valid-values";
import { useValidValuesManagement } from "../hooks/use-valid-values-management";
import ValidValuesTable from "./valid-values-table";
import ValidValueFormDialog from "./valid-value-form-dialog";
import ValidValueDeleteDialog from "./valid-value-delete-dialog";

interface TemplateValidValuesProps {
  templateId: number;
}

const TemplateValidValues = ({ templateId }: TemplateValidValuesProps) => {
  const { validValues, isLoading, mutate } = useValidValues(templateId);

  const {
    openDialog,
    newValue,
    editIndex,
    isSaving,
    setNewValue,
    handleOpenDialog,
    handleOpenEditDialog,
    handleCloseDialog,
    handleSave,
    deleteConfirmOpen,
    valueToDelete,
    isDeleting,
    handleDelete,
    handleConfirmDelete,
    handleCancelDelete,
  } = useValidValuesManagement({
    templateId,
    mutate,
  });

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: 3,
            mb: 0.5,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Typography variant="body2" fontWeight={600}>
              Valid Values
            </Typography>
            <Chip
              label={`${validValues?.length ?? 0} active`}
              size="small"
              color="primary"
              variant="outlined"
              sx={{ height: 20, fontSize: "0.7rem" }}
            />
          </Box>
          <IconButton
            size="small"
            color="success"
            onClick={handleOpenDialog}
            aria-label="Add new valid value"
          >
            <AddIcon fontSize="small" />
          </IconButton>
        </Box>
        <Divider sx={{ mb: 1 }} />

        <Box
          sx={{
            border: 1,
            borderColor: "grey.300",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <ValidValuesTable
            validValues={validValues ?? []}
            onEdit={handleOpenEditDialog}
            onDelete={handleDelete}
          />
        </Box>
      </Box>

      <ValidValueFormDialog
        open={openDialog}
        value={newValue}
        editIndex={editIndex}
        isSaving={isSaving}
        onClose={handleCloseDialog}
        onSave={handleSave}
        onChange={setNewValue}
      />

      <ValidValueDeleteDialog
        open={deleteConfirmOpen}
        value={valueToDelete}
        isDeleting={isDeleting}
        onCancel={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </>
  );
};

export default TemplateValidValues;
